// Control — Trustpilot visible
(function () {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      attributes: {
        '_showTrustpilot': 'false'
      }
    })
  });
})();